<template>
	<div
		class="modal fade"
		ref="modal"
		tabindex="-1"
		role="dialog"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-panel" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h1 class="modal-title">
						<i class="sk-icon-person-carry-box-solid"></i>
						Gate Delivery
					</h1>
					<button
						class="modal-close"
						aria-label="Close"
						@click="close"
					>
						<i class="sk-icon-times"></i>
					</button>
				</div>
				<div class="modal-body">
					<div class="modal-subtitle">
						Choose the gate your order will be delivered to.
						<div v-if="gateDeliveryFee" class="gate-delivery-fee">
							Subject to a
							{{ gateDeliveryFee | currency }} additional service
							fee
						</div>
					</div>
					<SkDropdownSelect
						v-model="gate"
						:options="gates"
						:position="dropdownPosition"
						class="sk-select-input"
					/>
					<button
						class="button button-primary"
						@click="updateGateNumber"
					>
						Update Gate Number
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-body {
	align-items: flex-start;
	padding: 20px 5px;
}

.modal-header {
	height: 55px;
	border: 1px solid var(--gR-white2);
}

.modal-subtitle {
	font-size: 12px;
	margin-bottom: 47px;
	margin-left: 15px;
}

.modal-subtitle,
.gate-delivery-fee {
	color: var(--sk-grey3);
}

.gate-delivery-fee {
	margin-top: 10px;
	font-size: 10px;
	font-style: italic;
}

.sk-select {
	margin-bottom: 100px;
}
@media only screen and (max-width: 1000px) {
	.sk-select {
		margin-bottom: 60px;
	}
}

.modal-body button.button.button-primary {
	max-width: calc(100% - 5px);
	margin: 0 5px;
}
</style>

<script>
import { DeliveryMode } from "@reef-os/utils/enums/deliveryMode"
import SkDropdownSelect from "@/components/common/SkDropdownSelect.vue"
import currencyFilterMixin from "@/mixins/currency-filter-mixin"
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"

export default {
	name: "GateDeliveryModal",
	mixins: [currencyFilterMixin, mobileResponsivenessMixin],
	components: {
		SkDropdownSelect
	},
	data: function () {
		return {
			gateLocationId: null
		}
	},
	computed: {
		dropdownPosition() {
			return this.isMobile ? "top" : "bottom"
		},
		gateDeliveryFee() {
			return this.$store.getters.deliveryFee
		},
		dropoffLocations() {
			const businessLocation = this.$store.getters.businessLocation
			if (businessLocation && businessLocation.dropoff_locations) {
				return businessLocation.dropoff_locations
			}
			return []
		},
		gates() {
			return this.dropoffLocations.reduce(
				(gates, gate) => {
					if (gate.delivery_mode == DeliveryMode.DIRECT_TO_LOCATION) {
						gates.push({
							id: gate.id,
							text: `${"Gate "}${gate.text}`
						})
					}
					return gates
				},
				[
					{
						id: null,
						text: "Gate Number"
					}
				]
			)
		},
		gate: {
			get: function () {
				return this.gates.find((gate) => gate.id == this.gateLocationId)
			},
			set: function (gate) {
				this.gateLocationId = gate.id
			}
		}
	},
	methods: {
		updateGateNumber() {
			if (this.gate && this.gate.id) {
				const dropoffLocation = this.dropoffLocations.find(
					(location) => location.id == this.gate.id
				)
				if (dropoffLocation) {
					this.$store.dispatch(
						"setDropoffLocationId",
						dropoffLocation
					)
				}
			}
			this.close()
		},
		open() {
			$(this.$refs.modal).modal("show")
		},
		close() {
			$(this.$refs.modal).modal("hide")
		},
		confirm() {
			this.close()
			this.consumePromise(true)
		}
	}
}
</script>
